module.exports = __webpack_public_path__ + "img/9788949704548.d2ecd137.jpg";